export default {
  app: {
    name: 'Business Management System',
    welcome: 'Welcome',
    logout: 'Logout',
    dashboard: 'Dashboard',
    language: 'Language',
    spanish: 'Spanish',
    english: 'English',
  },
  auth: {
    login: 'Login',
    register: 'Register',
    username: 'Username',
    password: 'Password',
    email: 'Email',
    fullName: 'Full Name',
    noAccount: "Don't have an account?",
    hasAccount: 'Already have an account?',
    loginSuccess: 'Login successful',
    loginError: 'Incorrect credentials',
    registerSuccess: 'User registered successfully',
  },
  nav: {
    companies: 'Companies',
    partners: 'Partners',
    inventory: 'Inventory',
    invoicing: 'Invoicing',
    accounting: 'Accounting',
    repair: 'Repairs',
    wallet: 'Wallet',
    chartOfAccounts: 'Chart of Accounts',
    journalEntries: 'Journal Entries',
    libroMayor: 'General Ledger',
    libroVentas: 'Sales Book',
    libroCompras: 'Purchases Book',
    declaracionIVA: 'VAT Declaration',
    retenciones: 'Withholdings',
    ingresos: 'Income',
    patrimonio: 'Equity',
    estadoResultados: 'Income Statement',
    balanceGeneral: 'Balance Sheet',
    formulario350: 'Form 350',
  },
  purchases: {
    title: 'Purchases',
    paymentMethod: {
      CASH: 'Cash',
      BANK_TRANSFER: 'Bank Transfer',
      CHECK: 'Check',
      CREDIT: 'Credit'
    },
    status: {
      DRAFT: 'Draft',
      ISSUED: 'Issued',
      PAID: 'Paid',
      PARTIAL: 'Partial',
      OVERDUE: 'Overdue',
      CANCELLED: 'Cancelled'
    }
  },
  common: {
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    search: 'Search',
    loading: 'Loading...',
    noData: 'No data available',
    confirm: 'Confirm',
    actions: 'Actions',
    total: 'Total',
    subtotal: 'Subtotal',
    tax: 'Tax',
    date: 'Date',
    status: 'Status',
    name: 'Name',
    description: 'Description',
    exportCSV: 'Export CSV',
    from: 'From',
    to: 'To',
    filter: 'Filter',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    dateFrom: 'Date From',
    dateTo: 'Date To',
    cutDate: 'Cut-off Date',
    period: 'Period',
    export: 'Export',
    viewDetail: 'View Detail',
  },
  accounting: {
    title: 'Accounting',
    createEntry: 'Create Entry',
    debit: 'Debit',
    credit: 'Credit',
    accountCode: 'Code',
    accountName: 'Account Name',
    accountType: 'Account Type',
    postEntry: 'Post Entry',
    balance: 'Balance',
    assets: 'Assets',
    liabilities: 'Liabilities',
    equity: 'Equity',
    revenue: 'Revenue',
    expenses: 'Expenses',
    costs: 'Costs',
    netIncome: 'Net Income',
    grossProfit: 'Gross Profit',
    initialBalance: 'Initial Balance',
    finalBalance: 'Final Balance',
    debits: 'Debits',
    credits: 'Credits',
    balanced: 'Balanced',
    notBalanced: 'Not Balanced',
    income: 'Income',
    operationalIncome: 'Operational Income',
    nonOperationalIncome: 'Non-Operational Income',
    grossIncome: 'Gross Income',
    costOfSales: 'Cost of Sales',
    operatingExpenses: 'Operating Expenses',
    financialExpenses: 'Financial Expenses',
    totalExpenses: 'Total Expenses',
    currentAssets: 'Current Assets',
    nonCurrentAssets: 'Non-Current Assets',
    totalCurrent: 'Total Current',
    totalNonCurrent: 'Total Non-Current',
    totalAssets: 'Total Assets',
    currentLiabilities: 'Current Liabilities',
    nonCurrentLiabilities: 'Non-Current Liabilities',
    totalLiabilities: 'Total Liabilities',
    totalEquity: 'Total Equity',
    retainedEarnings: 'Retained Earnings',
    utilidad: 'Net Income',
    equation: 'Equation',
  },
  partners: {
    title: 'Partner Management',
    createPartner: 'Create Partner',
    nit: 'Tax ID (NIT)',
    dv: 'Verification Digit',
    partnerType: 'Partner Type',
    fiscalResponsibility: 'Fiscal Responsibility',
    customer: 'Customer',
    supplier: 'Supplier',
    both: 'Both',
    creditLimit: 'Credit Limit',
  },
  inventory: {
    title: 'Inventory',
    createProduct: 'Create Product',
    sku: 'SKU',
    barcode: 'Barcode',
    scanBarcode: 'Scan Barcode',
    stockLevel: 'Stock Level',
    minStock: 'Min Stock',
    maxStock: 'Max Stock',
    purchasePrice: 'Purchase Price',
    salePrice: 'Sale Price',
    lowStock: 'Low Stock',
  },
  invoicing: {
    title: 'Invoicing',
    createInvoice: 'Create Invoice',
    invoiceNumber: 'Invoice #',
    invoiceType: 'Invoice Type',
    sale: 'Sale',
    purchase: 'Purchase',
    sendToDian: 'Send to DIAN',
    creditNote: 'Credit Note',
    debitNote: 'Debit Note',
    estadoDian: 'DIAN Status',
    draft: 'Draft',
    sent: 'Sent',
    accepted: 'Accepted',
    rejected: 'Rejected',
  },
  accounting: {
    title: 'Accounting',
    createEntry: 'Create Entry',
    debit: 'Debit',
    credit: 'Credit',
    accountCode: 'Code',
    accountName: 'Account Name',
    accountType: 'Account Type',
    postEntry: 'Post Entry',
    balance: 'Balance',
    assets: 'Assets',
    liabilities: 'Liabilities',
    equity: 'Equity',
    revenue: 'Revenue',
    expenses: 'Expenses',
    costs: 'Costs',
    netIncome: 'Net Income',
    grossProfit: 'Gross Profit',
    initialBalance: 'Initial Balance',
    finalBalance: 'Final Balance',
    debits: 'Debits',
    credits: 'Credits',
    balanced: 'Balanced',
    notBalanced: 'Not Balanced',
  },
  repair: {
    title: 'Repairs',
    createOrder: 'Create Order',
    orderNumber: 'Order #',
    status: 'Status',
    technician: 'Technician',
    warranty: 'Warranty',
    received: 'Received',
    diagnosis: 'Diagnosis',
    approved: 'Approved',
    inRepair: 'In Repair',
    waitingParts: 'Waiting Parts',
    ready: 'Ready',
    delivered: 'Delivered',
    cancelled: 'Cancelled',
    generateInvoice: 'Generate Invoice',
  },
  wallet: {
    title: 'Wallet',
    deposit: 'Deposit',
    withdraw: 'Withdraw',
    balance: 'Balance',
    transactions: 'Transactions',
    loyaltyPoints: 'Loyalty Points',
    redeemPoints: 'Redeem Points',
  },
  platform: {
    title: 'Platform',
    tenants: 'Companies',
    createTenant: 'Create Company',
    tenantDetail: 'Company Detail',
    active: 'Active',
    inactive: 'Inactive',
    activate: 'Activate',
    deactivate: 'Deactivate',
    adminUser: 'Admin User',
    users: 'Users',
    toggleActive: 'Toggle Active',
  },
}
